#pie-spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
#pie-spinner {
  max-width: 50%;
}